export default "__VITE_ASSET__BFVkASCr__"